__turbopack_context__.v({
  "alert": "Auth-module__-u2vAq__alert",
  "alertError": "Auth-module__-u2vAq__alertError",
  "alertSuccess": "Auth-module__-u2vAq__alertSuccess",
  "authCard": "Auth-module__-u2vAq__authCard",
  "authFooter": "Auth-module__-u2vAq__authFooter",
  "authForm": "Auth-module__-u2vAq__authForm",
  "authLogo": "Auth-module__-u2vAq__authLogo",
  "authPage": "Auth-module__-u2vAq__authPage",
  "authSpin": "Auth-module__-u2vAq__authSpin",
  "authSubtitle": "Auth-module__-u2vAq__authSubtitle",
  "authTitle": "Auth-module__-u2vAq__authTitle",
  "checkboxGroup": "Auth-module__-u2vAq__checkboxGroup",
  "divider": "Auth-module__-u2vAq__divider",
  "facebookButton": "Auth-module__-u2vAq__facebookButton",
  "fieldError": "Auth-module__-u2vAq__fieldError",
  "forgotPassword": "Auth-module__-u2vAq__forgotPassword",
  "formGroup": "Auth-module__-u2vAq__formGroup",
  "formInput": "Auth-module__-u2vAq__formInput",
  "formInputError": "Auth-module__-u2vAq__formInputError",
  "formLabel": "Auth-module__-u2vAq__formLabel",
  "formRow": "Auth-module__-u2vAq__formRow",
  "githubButton": "Auth-module__-u2vAq__githubButton",
  "googleButton": "Auth-module__-u2vAq__googleButton",
  "passwordToggle": "Auth-module__-u2vAq__passwordToggle",
  "passwordToggleButton": "Auth-module__-u2vAq__passwordToggleButton",
  "spinner": "Auth-module__-u2vAq__spinner",
  "submitButton": "Auth-module__-u2vAq__submitButton",
  "twitterButton": "Auth-module__-u2vAq__twitterButton",
});
